import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'

interface Hotel {
  id: string
  name: string
  address: string
  chain: string
  rate: number
  lat: number
  lng: number
  active: number
}

export function Hotels() {
  const [hotels, setHotels] = useState<Hotel[]>([])
  const [loading, setLoading] = useState(true)
  const [showAdd, setShowAdd] = useState(false)
  const [newHotel, setNewHotel] = useState({ name: '', address: '', chain: 'Travelodge', rate: 44 })

  useEffect(() => {
    fetchHotels()
  }, [])

  async function fetchHotels() {
    try {
      const data = await apiFetch('/api/hotels')
      setHotels(data.hotels || [])
    } catch {}
    setLoading(false)
  }

  async function addHotel(e: React.FormEvent) {
    e.preventDefault()
    try {
      await apiFetch('/api/admin/hotels', {
        method: 'POST',
        body: JSON.stringify(newHotel),
      })
      setShowAdd(false)
      setNewHotel({ name: '', address: '', chain: 'Travelodge', rate: 44 })
      fetchHotels()
    } catch (err) {
      alert('Failed to add hotel')
    }
  }

  if (loading) return <div className="loading">Loading hotels...</div>

  return (
    <div className="page">
      <header className="page-header">
        <h1>Hotels</h1>
        <p>{hotels.length} partner hotels</p>
        <button className="btn-primary" onClick={() => setShowAdd(true)}>
          Add Hotel
        </button>
      </header>

      {showAdd && (
        <div className="modal-overlay" onClick={() => setShowAdd(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Add Hotel</h2>
            <form onSubmit={addHotel}>
              <div className="field">
                <label>Hotel Name</label>
                <input
                  type="text"
                  value={newHotel.name}
                  onChange={(e) => setNewHotel({ ...newHotel, name: e.target.value })}
                  required
                  className="input"
                />
              </div>
              <div className="field">
                <label>Address</label>
                <input
                  type="text"
                  value={newHotel.address}
                  onChange={(e) => setNewHotel({ ...newHotel, address: e.target.value })}
                  required
                  className="input"
                />
              </div>
              <div className="field">
                <label>Chain</label>
                <select
                  value={newHotel.chain}
                  onChange={(e) => setNewHotel({ ...newHotel, chain: e.target.value })}
                  className="input"
                >
                  <option value="Travelodge">Travelodge</option>
                  <option value="Premier Inn">Premier Inn</option>
                  <option value="Holiday Inn">Holiday Inn</option>
                  <option value="Ibis">Ibis</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="field">
                <label>Rate (£/night)</label>
                <input
                  type="number"
                  value={newHotel.rate}
                  onChange={(e) => setNewHotel({ ...newHotel, rate: Number(e.target.value) })}
                  required
                  className="input"
                />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowAdd(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn-primary">
                  Add Hotel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Address</th>
              <th>Chain</th>
              <th>Rate</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {hotels.map(hotel => (
              <tr key={hotel.id}>
                <td>{hotel.name}</td>
                <td>{hotel.address}</td>
                <td>{hotel.chain}</td>
                <td>£{hotel.rate}</td>
                <td>
                  <span className={`status-badge ${hotel.active ? 'active' : 'inactive'}`}>
                    {hotel.active ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
